jQuery(document).ready( function($) {
    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    function checkVisibility() {
        $(".wp-block-heading, .story-info, .featured-products, .featured-news .slide-in-container, .featured-events .slide-in-container, .awards-section").each(function () {
            let elementTop = $(this).offset().top;
            let elementHeight = $(this).outerHeight();
            let elementMid = elementTop + elementHeight / 2;
            let windowTop = $(window).scrollTop();
            let isMobileDevice = isMobile() || $(window).width() < 1200;
            let offset = isMobileDevice ? 0 : 100;
            let windowBottom = windowTop + $(window).height() - offset;
            let triggerPoint = isMobileDevice ? elementTop - 100 : elementMid;

            if (triggerPoint < windowBottom) {
                $(this).addClass("visible");
            }
        });
    }

    // Run on scroll and on page load
    $(window).on("scroll", checkVisibility);
    checkVisibility();
    if ( $('body .products-container').length > 0 ) {
        $('.products-container').slick({
            dots: false,
            infinite: false,
            slidesToShow: 3.3,
            slidesToScroll: 3,
            autoplay: false,
            arrows: false,
            // prevArrow: '<button type="button" class="slick-prev d-flex align-items-center justify-content-center"><svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor"\n' +
            //     '                                             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">\n' +
            //     '                                            <line x1="19" y1="12" x2="5" y2="12"/>\n' +
            //     '                                            <polyline points="12 19 5 12 12 5"/>\n' +
            //     '                                        </svg></button>',
            // nextArrow: '<button type="button" class="slick-next d-flex align-items-center justify-content-center"><svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">\n' +
            //     '                                            <line x1="5" y1="12" x2="19" y2="12"></line>\n' +
            //     '                                            <polyline points="12 5 19 12 12 19"></polyline>\n' +
            //     '                                        </svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1.95,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.75,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.15,
                        slidesToScroll: 1
                    }
                }
            ],
        });
    }
    if ( $('body .customer-stories-container').length > 0 ) {
        $('.customer-stories-container').slick({
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
        });
    }

});